<template>
  <div class="page">
    <div class="page-content">
      <v-row>
        <v-col cols="3" class="d-flex align-stretch" v-for="app in apps" :key="app.id">
          <v-card
            class="index-card"
            outlined
            dark
            elevation="1"
            :class="{ readonly: app.readonly }"
          >
            <div class="card-header">
              <div class="index-title">{{ app.index }}</div>
            </div>

            <v-col cols="12">
              <v-switch
                v-model="app.readonly"
                :true-value="false"
                :false-value="true"
                color="success"
                :label="app.readonly ? 'Somente leitura' : 'Leitura e gravação'"
                dark
                @change="updateDebounced(app)"
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="app.limit_fields"
                label="Limite de campos"
                dark
                outlined
                dense
                @change="updateDebounced(app)"
              ></v-text-field>
            </v-col>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-snackbar
      v-model="snackbar.open"
      :color="snackbar.color"
      left
      :timeout="1000"
    >
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import { logElastic } from '../service/Api'
import * as _ from 'lodash'
import moment from 'moment'
export default {
  name: 'Logaudit',
  data: () => ({
    apps: [],
    snackbar: {
      open: false,
      message: '',
      color: 'info',
    },
  }),
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      logElastic
        .list()
        .then(data => {
          this.apps = _.get(data, 'data', [])
        })
        .catch(err => {
          this.snackbar = {
            open: true,
            message: _.get(
              err,
              'response.data.message',
              'Falha ao buscar indices do elastic'
            ),
            color: 'error',
          }
        })
    },
    updateDebounced(app) {
      logElastic
        .updateSettings(app.index, {
          readonly: app.readonly,
          limitFields: app.limit_fields,
        })
        .then(() => {
          this.snackbar = {
            open: true,
            message: 'Configurações do index atualizada',
            color: 'success',
          }
        })
        .catch(err => {
          this.snackbar = {
            open: true,
            message: _.get(
              err,
              'response.data.message',
              'Falha ao buscar indices do elastic'
            ),
            color: 'error',
          }
        })
    },
  },
}
</script>

<style lang="scss">
.index-card {
  padding: 10px;
}
.card-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .index-title {
    font-size: 14px;
    padding: 5px;
    text-align: left;
  }
}
.log-field {
  text-align: left;
  .log-label {
    font-size: 900;
  }
  .log-value {
    font-size: 13px;
  }
}
</style>
